(function () {
  const TRANSITION_KEYS = [
    'all_reviews_widget_v2025_carousel_transition_speed',
    'review_widget_carousel_transition_speed',
    'featured_carousel_autoslide_interval',
  ];

  let settingsObserver = null;
  let disconnectTimer = null;
  let carouselsPatched = 0;

  function patchJudgeMeSettings() {
    if (!window.jdgmSettings) return false;
    TRANSITION_KEYS.forEach((key) => {
      if (key in window.jdgmSettings) window.jdgmSettings[key] = 0;
    });
    return true;
  }

  function disableCarouselAutoplay(carousel) {
    if (carousel.dataset.autoplayDisabled) return;
    carousel.dataset.autoplayDisabled = 'true';
    carouselsPatched += 1;

    carousel.addEventListener(
      'mouseleave',
      (event) => {
        event.stopImmediatePropagation();
      },
      true
    );

    carousel.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
  }

  function scanCarousels() {
    document.querySelectorAll('.jm-carousel').forEach(disableCarouselAutoplay);
  }

  function maybeDisconnect() {
    if (disconnectTimer) clearTimeout(disconnectTimer);
    disconnectTimer = setTimeout(() => {
      // Settings + at least one carousel, or settings after wait with no carousel.
      if (patchJudgeMeSettings() && (carouselsPatched > 0 || document.querySelector('.jdgm-rev-widg, .jdgm-carousel-wrapper, [class*="jdgm"]'))) {
        if (settingsObserver) {
          settingsObserver.disconnect();
          settingsObserver = null;
        }
      }
    }, 8000);
  }

  function onMutation() {
    patchJudgeMeSettings();
    scanCarousels();
    maybeDisconnect();
  }

  patchJudgeMeSettings();

  settingsObserver = new MutationObserver(onMutation);
  settingsObserver.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      patchJudgeMeSettings();
      scanCarousels();
      maybeDisconnect();
    });
  } else {
    scanCarousels();
    maybeDisconnect();
  }
})();
